import { useEffect } from 'react'

import http from '../../lib/http'

interface PatientViewerProps {
  clientName: string
  patientId: string
}

export function PatientViewer ({ patientId, clientName }: PatientViewerProps): JSX.Element | null {
  useEffect(() => {
    http.postRequest(`/patients/${patientId}/views`, {}, { clientName })
      .catch((err: unknown) => {
        console.error(err)
      })
  }, [
    patientId,
    clientName
  ])

  return null
}
